import {gql} from '@apollo/client';
import React from 'react';

import {useSkippableBenchlingQuery} from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';

import {ProcessTaskSchemaSubdependenciesQuery} from './__generated/ProcessTaskSchemaSubdependenciesQuery';
import BaseSchemaSubdependencyInput from './BaseSchemaSubdependencyInput';
import {ChildDependencyTypes} from './ChildDependencyTypes';

export const PROCESS_TASK_SCHEMA_SUBDEPENDENCIES_QUERY = gql`
  query ProcessTaskSchemaSubdependenciesQuery($id: StrictString!)
  @skipAudit
  @engComponent(name: BENCHLING_APPS) {
    processTaskSchema(id: $id) {
      ... on ProcessTaskSchemaNode {
        id
        allFieldsJson
        outputSchema {
          id
          allFieldsJson
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export default function ProcessTaskSchemaFieldInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<ProcessTaskSchemaSubdependenciesQuery>(
    PROCESS_TASK_SCHEMA_SUBDEPENDENCIES_QUERY,
    {
      skip: parentDependencySelectedId == null,
      variables: {id: parentDependencySelectedId},
    }
  );
  return (
    <BaseSchemaSubdependencyInput<ProcessTaskSchemaSubdependenciesQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => result.data.processTaskSchema}
      parentdependencyType="Task"
    />
  );
}

export function ProcessTaskSchemaOutputFieldInput({
  subdependencies,
  onChange,
  dependencyValidation,
  updateDependencyConfigValidation,
  disabled,
  parentDependencySelectedId,
}: ChildDependencyTypes): JSX.Element | null {
  const result = useSkippableBenchlingQuery<ProcessTaskSchemaSubdependenciesQuery>(
    PROCESS_TASK_SCHEMA_SUBDEPENDENCIES_QUERY,
    {
      skip: parentDependencySelectedId == null,
      variables: {id: parentDependencySelectedId},
    }
  );
  return (
    <BaseSchemaSubdependencyInput<ProcessTaskSchemaSubdependenciesQuery>
      subdependencies={subdependencies}
      onChange={onChange}
      dependencyValidation={dependencyValidation}
      updateDependencyConfigValidation={updateDependencyConfigValidation}
      disabled={disabled}
      result={result}
      getSchemaFromResult={(result) => {
        const schema = result.data.processTaskSchema;
        if (isInaccessible(schema)) {
          return null;
        }
        return schema.outputSchema;
      }}
      fieldName="Output Field"
      parentdependencyType=""
      isWorkflowOutput={true}
    />
  );
}
